export default __webpack_public_path__ + "static/media/directors-icon.22e06d19.svg";